import { useEffect, useRef, useState } from 'react';
import styles from './SelectOval.module.scss';
import ArrowDownIcon from '@/assets/icons/arrow-down.svg?react';

interface Option {
  label: string;
  value: string;
}

interface NavigationSelectProps {
  value: string;
  options: Option[];
  // eslint-disable-next-line no-unused-vars
  setValue: (value: string) => void;
}

export default function SelectOval({ value, options, setValue }: NavigationSelectProps) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectValue = (value: string) => {
    setOpen(false);
    setValue(value);
  };

  return (
    <div className={`${styles.wrapper}`} ref={wrapperRef}>
      <button className={styles.selectButton} type="button" onClick={() => setOpen((prev) => !prev)}>
        {value}
        <ArrowDownIcon className={styles.arrowDownIcon} />
      </button>
      {open && (
        <div className={styles.dropdown}>
          {options.map(({ label, value }) => (
            <div key={label} className={styles.option}>
              <button onClick={() => selectValue(value)}>{label}</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
